import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdDefaultThreshold } from "../../constants/IdDefaultThreshold";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectDoghouseInfo } from "../../selectors/selectDoghouseInfo";
import { selectResourceData } from "../../selectors/selectResourceInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ResourceWithThreshold } from "../generic/resource-with-threshold/ResourceWithThreshold";
import { actionDoghouseRequestExchangeFreeTreats } from "./actionDoghouse";
var _DoghouseFreeTreatsGivenFooter = function (_a) {
    var premiumTreatResource = _a.premiumTreatResource, doghouseInfo = _a.doghouseInfo, onClick = _a.onClick;
    var availableAmount = doghouseInfo.freeTreatsGiven;
    var requiredAmount = IdDefaultThreshold.FreeDogTreatExchange;
    var isComplete = availableAmount >= requiredAmount;
    var guardedOnClick = function () {
        if (isComplete) {
            var amount = Math.floor(availableAmount / requiredAmount);
            if (amount >= 1) {
                onClick(amount);
            }
        }
    };
    return (React.createElement(ResourceWithThreshold, { resource: premiumTreatResource, available: availableAmount, required: requiredAmount, styleId: IdStyles.IconLarge, onButtonClick: guardedOnClick, tooltipLoca: IdLoca.dogTreat_premium }));
};
var mapState = function (state) {
    return {
        doghouseInfo: selectDoghouseInfo(state),
        premiumTreatResource: selectResourceData(state, IdResource.DogtreatPremium),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClick: actionDoghouseRequestExchangeFreeTreats,
    }, dispatch);
};
export var DoghouseFreeTreatsGivenFooter = connect(mapState, mapDispatch)(_DoghouseFreeTreatsGivenFooter);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DoghouseFreeTreatsGivenFooter.tsx
// module id = 948
// module chunks = 3